import { Screen } from "../../utils/sharedTypes";
var NavigationType;
(function (NavigationType) {
    NavigationType["INTERNAL"] = "Internal";
    NavigationType["EXTERNAL"] = "External";
})(NavigationType || (NavigationType = {}));
var CmsScreen;
(function (CmsScreen) {
    CmsScreen["HOME"] = "HOME";
    CmsScreen["RECOMMENDATION"] = "RECOMMENDATION";
    CmsScreen["FAVORITE_BOTS"] = "FAVORITE_BOTS";
    CmsScreen["MY_CHATBOTS"] = "MY_CHATBOTS";
    CmsScreen["MY_CHATS"] = "MY_CHATS";
    CmsScreen["EDIT_CHATBOT"] = "EDIT_CHATBOT";
    CmsScreen["LEADERBOARD"] = "LEADERBOARD";
    CmsScreen["PERSONAS"] = "PERSONAS";
    CmsScreen["CREATE_PERSONA"] = "CREATE_PERSONA";
    CmsScreen["SALE"] = "SALE";
    CmsScreen["SUBSCRIBE"] = "SUBSCRIBE";
    CmsScreen["BLOCKED_CREATORS"] = "BLOCKED_CREATORS";
    CmsScreen["REPORT"] = "REPORT";
    CmsScreen["PROFILE"] = "PROFILE";
    CmsScreen["TERMS"] = "TERMS";
    CmsScreen["PRIVACY"] = "PRIVACY";
    CmsScreen["REFUNDS"] = "REFUNDS";
    CmsScreen["PAGE_2257"] = "PAGE_2257";
    CmsScreen["DOWNLOAD"] = "DOWNLOAD";
    CmsScreen["PERSONA_EDIT"] = "PERSONA_EDIT";
    CmsScreen["CHATBOT_PROFILE"] = "CHATBOT_PROFILE";
    CmsScreen["CREATOR_PAGE"] = "CREATOR_PAGE";
    CmsScreen["SAVED_CHATS"] = "SAVED_CHATS";
    CmsScreen["CHAT"] = "CHAT";
    CmsScreen["CREATE_CHATBOT"] = "CREATE_CHATBOT";
    CmsScreen["CHECKOUT"] = "CHECKOUT";
    CmsScreen["CHECKOUT_SUCCESS"] = "CHECKOUT_SUCCESS";
})(CmsScreen || (CmsScreen = {}));
const CONTENTFUL_SCREENS = {
    [CmsScreen.HOME]: "Home",
    [CmsScreen.RECOMMENDATION]: "Recommendation",
    [CmsScreen.FAVORITE_BOTS]: "FavoriteChatbots",
    [CmsScreen.MY_CHATBOTS]: "MyChatbots",
    [CmsScreen.MY_CHATS]: "MyChats",
    [CmsScreen.EDIT_CHATBOT]: "EditChatbot",
    [CmsScreen.LEADERBOARD]: "Leaderboard",
    [CmsScreen.PERSONAS]: "Personas",
    [CmsScreen.CREATE_PERSONA]: "CreatePersona",
    [CmsScreen.SALE]: "BirthdaySale",
    [CmsScreen.SUBSCRIBE]: "SubscriptionPage",
    [CmsScreen.BLOCKED_CREATORS]: "BlockedCreator",
    [CmsScreen.REPORT]: "ReportPage",
    [CmsScreen.PROFILE]: "ProfileSetting",
    [CmsScreen.TERMS]: "Terms",
    [CmsScreen.PRIVACY]: "Privacy",
    [CmsScreen.REFUNDS]: "Refunds",
    [CmsScreen.PAGE_2257]: "Page2257",
    [CmsScreen.DOWNLOAD]: "Download",
    [CmsScreen.PERSONA_EDIT]: "EditPersona",
    [CmsScreen.CHATBOT_PROFILE]: "ChatbotProfile",
    [CmsScreen.CREATOR_PAGE]: "CreatorPage",
    [CmsScreen.SAVED_CHATS]: "SavedChats",
    [CmsScreen.CHAT]: "Chat",
    [CmsScreen.CREATE_CHATBOT]: "CreateChatbot",
};
var ContentFulScreens;
(function (ContentFulScreens) {
    ContentFulScreens["REGISTER"] = "Register";
    ContentFulScreens["PERSONAS"] = "Personas";
    ContentFulScreens["CREATE_PERSONA"] = "CreatePersona";
    ContentFulScreens["SALE"] = "BirthdaySale";
    ContentFulScreens["RECOMMENDATION"] = "Recommendation";
    ContentFulScreens["FAVORITE_BOTS"] = "FavoriteChatbots";
    ContentFulScreens["SUBSCRIBE"] = "SubscriptionPage";
    ContentFulScreens["BLOCKED_CREATORS"] = "BlockedCreator";
    ContentFulScreens["REPORT"] = "ReportPage";
    ContentFulScreens["SIGN_UP"] = "WelcomeAboard";
    ContentFulScreens["PROFILE"] = "ProfileSetting";
    ContentFulScreens["MY_CHATBOTS"] = "MyChatbots";
    ContentFulScreens["MY_CHATS"] = "MyChats";
    ContentFulScreens["HOME"] = "Home";
    ContentFulScreens["EDIT_CHATBOT"] = "EditChatbot";
    ContentFulScreens["LEADERBOARD"] = "Leaderboard";
    ContentFulScreens["TERMS"] = "Terms";
    ContentFulScreens["PRIVACY"] = "Privacy";
    ContentFulScreens["REFUNDS"] = "Refunds";
    ContentFulScreens["PAGE_2257"] = "Page2257";
    ContentFulScreens["DOWNLOAD"] = "Download";
    ContentFulScreens["PERSONA_EDIT"] = "EditPersona";
    ContentFulScreens["CHATBOT_PROFILE"] = "ChatbotProfile";
    ContentFulScreens["CREATOR_PAGE"] = "CreatorPage";
    ContentFulScreens["TAG_PAGE"] = "TagPage";
    ContentFulScreens["SAVED_CHATS"] = "SavedChats";
    ContentFulScreens["CHAT"] = "Chat";
    ContentFulScreens["CREATE_CHATBOT"] = "CreateChatbot";
})(ContentFulScreens || (ContentFulScreens = {}));
export var ContentPlacement;
(function (ContentPlacement) {
    ContentPlacement["TopLeft"] = "topLeft";
    ContentPlacement["TopCenter"] = "topCenter";
    ContentPlacement["TopRight"] = "topRight";
    ContentPlacement["MiddleLeft"] = "middleLeft";
    ContentPlacement["MiddleCenter"] = "middleCenter";
    ContentPlacement["MiddleRight"] = "middleRight";
    ContentPlacement["BottomLeft"] = "bottomLeft";
    ContentPlacement["BottomCenter"] = "bottomCenter";
    ContentPlacement["BottomRight"] = "bottomRight";
})(ContentPlacement || (ContentPlacement = {}));
export var ActionPlacement;
(function (ActionPlacement) {
    ActionPlacement["TopLeft"] = "topLeft";
    ActionPlacement["TopCenter"] = "topCenter";
    ActionPlacement["TopRight"] = "topRight";
    ActionPlacement["MiddleLeft"] = "middleLeft";
    ActionPlacement["MiddleRight"] = "middleRight";
    ActionPlacement["BottomLeft"] = "bottomLeft";
    ActionPlacement["BottomCenter"] = "bottomCenter";
    ActionPlacement["BottomRight"] = "bottomRight";
})(ActionPlacement || (ActionPlacement = {}));
export var Shape;
(function (Shape) {
    Shape["Rounded"] = "Rounded";
    Shape["Square"] = "Square";
})(Shape || (Shape = {}));
export var BannerType;
(function (BannerType) {
    BannerType["Top"] = "Top";
    BannerType["Inline"] = "In-line";
    BannerType["Bottom"] = "Bottom";
    BannerType["PopUp"] = "Pop-up";
})(BannerType || (BannerType = {}));
export var Platform;
(function (Platform) {
    Platform["NATIVE"] = "Native";
    Platform["MOBILE_WEB"] = "M-Web";
    Platform["TABLET_WEB"] = "T-Web";
    Platform["DESKTOP_WEB"] = "D-Web";
})(Platform || (Platform = {}));
export { CmsScreen, CONTENTFUL_SCREENS, ContentFulScreens, NavigationType };
